import { apiClient, unwrap } from './client';
import { storage } from '../lib/storage';
import type { ApiEnvelope, AuthPayload } from './types';

export interface SignupInput {
  name: string;
  email: string;
  password: string;
}

export interface LoginInput {
  email: string;
  password: string;
}

// Сервер не возвращает токен — на email уходит письмо подтверждения.
// После клика на ссылку в письме (EJS /auth/confirm-email) пользователь идёт
// логиниться сам.
export async function signup(input: SignupInput): Promise<void> {
  await apiClient.post<ApiEnvelope<null>>('/api/auth/signup', {
    ...input,
    sessionId: storage.getSessionId(),
  });
}

export async function login(input: LoginInput): Promise<AuthPayload> {
  const { data } = await apiClient.post<ApiEnvelope<AuthPayload>>('/api/auth/signin', input);
  return unwrap(data);
}

export async function resendEmailConfirmation(email: string): Promise<void> {
  await apiClient.post<ApiEnvelope<null>>('/api/auth/email/resend', { email });
}

export async function restoreRequest(email: string): Promise<{ guid: string }> {
  const { data } = await apiClient.post<ApiEnvelope<{ guid: string }>>('/api/auth/restore', {
    email,
  });
  return unwrap(data);
}

export interface RestoreConfirmInput {
  guid: string;
  code: string;
  password: string;
  passwordRepeat: string;
}

// Возвращает null — после смены пароля пользователь логинится обычным путём.
export async function restoreConfirm(input: RestoreConfirmInput): Promise<void> {
  await apiClient.post<ApiEnvelope<null>>('/api/auth/restore/confirm', input);
}

export async function logout(userGUID: string): Promise<void> {
  await apiClient.post(`/api/user/${userGUID}/logout`);
}
